import MUIGrid from '@/components/MUI-Components/MUI-Grid';
import MUITypography from '@/components/MUI-Components/MUI-Typography';
import React, {Fragment, memo} from 'react';
import DisplayImage from '../display-image';
import Box from '@mui/material/Box';

// Migrated from globals.scss `.fintech-container` (tabScreen + mobileScreen
// overrides — both set the same value, so a single ≤768px query covers both).
const sxFintechContainer = {
    '@media (max-width: 768px)': {
        textAlign: 'center'
    }
};

const FintechSecurity = (props: any) => {
    const {heading, subheading, fintechSecurity} = props;
    return (
        <Box>
            <Box className="spectrum-header-wrapper solutions">
                <MUITypography className="spectrum-heading top-space color-black">{heading}</MUITypography>
                <Box className="divder-wrapper">
                    <hr className="divider-line" />
                </Box>
                <Box className="sub-heading-box">
                    <MUITypography className="spectrum-sub-heading color-black spacing">{subheading}</MUITypography>
                </Box>
            </Box>
            <MUIGrid container spacing={3} className="top-spacing" sx={sxFintechContainer}>
                {fintechSecurity?.map((data: any, index: number) => (
                    <Fragment key={index}>
                        <MUIGrid item xs={6} sm={2} md={2} lg={2}>
                            <DisplayImage src={data.img} alt={data.alt} priority={true} className="step-image" />
                        </MUIGrid>
                    </Fragment>
                ))}
            </MUIGrid>
        </Box>
    );
};
export default memo(FintechSecurity);
